<app-default>
  <div class="container pt-5 pb-5">
    <h1 class="title">Phương thức giao – nhận hàng</h1>
    <p>Nhân viên <strong>Eco Express</strong>&nbsp;có thể nhận hàng theo địa chỉ của quý khác (đối với hàng gửi) và giao hàng theo địa chỉ của quý khách (đối với dịch vụ chuyển phát nhanh từ nước ngoài về Việt Nam) nếu hai bên có thỏa thuận và đồng ý thỏa thuận lúc đàm phán.</p>
    <p>Khách hàng có thể đến trực tiếp văn phòng Eco Express để gửi/ nhận hàng (đối với cả hàng gửi đi và hàng từ nước ngoài gửi về Việt Nam)</p>
    <p>Thời gian giao/nhận hàng tùy thuộc vào điều kiện cụ thể lúc giao hàng như vấn đề thanh toán hay các ảnh hưởng về thời tiết.</p>
  </div>
</app-default>
